import { Toaster as Sonner } from "sonner"
import { CircleCheck, CircleX, Info, TriangleAlert, LoaderCircle } from "lucide-react"
import { useDarkMode } from "@/shared/hooks/useDarkMode"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { darkMode } = useDarkMode()

  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      duration={5000}
      theme={darkMode ? "dark" : "light"}
      icons={{
        success: <CircleCheck className="h-5 w-5 text-success" />,
        error: <CircleX className="h-5 w-5 text-destructive" />,
        info: <Info className="h-5 w-5 text-info" />,
        warning: <TriangleAlert className="h-5 w-5 text-warning" />,
        loading: <LoaderCircle className="h-5 w-5 text-info animate-spin" />,
      }}
      toastOptions={{
        style: { zoom: 1.1 },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:text-sm group-[.toaster]:py-4 group-[.toaster]:px-4",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-xs",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
	          error:
	            "group-[.toaster]:!border-l-4 group-[.toaster]:!border-l-destructive group-[.toaster]:!bg-[color-mix(in_oklch,var(--destructive)_10%,var(--background))] group-[.toaster]:!shadow-[0_4px_12px_color-mix(in_oklch,var(--destructive)_12%,transparent)]",
	          success:
	            "group-[.toaster]:!border-l-4 group-[.toaster]:!border-l-success group-[.toaster]:!bg-[var(--success-soft)]",
	          warning:
	            "group-[.toaster]:!border-l-4 group-[.toaster]:!border-l-warning group-[.toaster]:!bg-[var(--warning-soft)]",
	          info:
	            "group-[.toaster]:!bg-[var(--info-soft)]",
	          loading:
	            "group-[.toaster]:!bg-[var(--info-soft)]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
